import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div>
      <p>
        Sorry, we could not find this page
        <br />
        <Link to={`${process.env.PUBLIC_URL}/`}>Return to Home Page</Link>
      </p>
    </div>
  );
}

export default NotFound;
